import AccountProfile from "../components/AccountProfile";
import BaseLayout from "../layout/BaseLayout";

export default function AccountProfilePage() {
    
    return (
            <BaseLayout child={<AccountProfile />}/>
    )
}
